import { useState } from 'react'
import { IntentionalLivingScoreCardV2 } from '@/components/intentional-living-score-card-v2'
import { IntentionalLivingDisciplineCard } from '@/components/intentional-living-discipline-card'
import { useInsightsV2 } from '@/hooks/use-insights-v2'
import { useInsightsWeek } from '@/context/insights-week-context'
import { useAuth } from '@/context/auth-context'
import { toast } from 'sonner'

export function InsightsPage() {
  const { currentWeekStart } = useInsightsWeek()
  const { user } = useAuth()
  const { data, loading, refresh } = useInsightsV2(currentWeekStart)
  const [isRefreshing, setIsRefreshing] = useState(false)

  const handleRefresh = async () => {
    if (!user?.id) {
      toast.error('User not authenticated')
      return
    }

    setIsRefreshing(true)

    try {
      const result = await refresh()
      const success = result?.success ?? false
      
      if (success) {
        toast.success('Insights refreshed successfully!')
      } else {
        toast.error(result?.error || 'Failed to refresh insights')
      }
    } catch (error) {
      console.error('💥 Refresh failed:', error)
      toast.error('Failed to refresh insights')
    } finally {
      setIsRefreshing(false)
    }
  }

  return (
    <div className="main-content">
      {/* Intentional Living Score Card */}
      <IntentionalLivingScoreCardV2 
        data={data} 
        intentionalLivingData={data}
        loading={loading} 
        className="mb-8"
        onRefresh={handleRefresh}
        isRefreshing={isRefreshing}
      />

      {/* Intentional Living Discipline Card */}
      <IntentionalLivingDisciplineCard
        data={data}
        loading={loading}
      />
    </div>
  )
}

